import { render } from "./SignUpPayment.vue?vue&type=template&id=24eba79c&scoped=true"
import script from "./SignUpPayment.vue?vue&type=script&lang=js"
export * from "./SignUpPayment.vue?vue&type=script&lang=js"

import "./SignUpPayment.vue?vue&type=style&index=0&id=24eba79c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eba79c"]])

export default __exports__